var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 4.66602C8.50033 4.38987 8.27647 4.16602 8.00033 4.16602C7.72418 4.16602 7.50033 4.38987 7.50033 4.66602V7.99935C7.50033 8.17174 7.58914 8.33198 7.73533 8.42335L9.73533 9.67335C9.96949 9.8197 10.278 9.74852 10.4243 9.51435C10.5707 9.28018 10.4995 8.9717 10.2653 8.82535L8.50033 7.72222V4.66602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 2.16602C4.77866 2.16602 2.16699 4.77769 2.16699 7.99935C2.16699 11.221 4.77866 13.8327 8.00033 13.8327C11.222 13.8327 13.8337 11.221 13.8337 7.99935C13.8337 4.77769 11.222 2.16602 8.00033 2.16602ZM3.16699 7.99935C3.16699 5.32997 5.33095 3.16602 8.00033 3.16602C10.6697 3.16602 12.8337 5.32997 12.8337 7.99935C12.8337 10.6687 10.6697 12.8327 8.00033 12.8327C5.33095 12.8327 3.16699 10.6687 3.16699 7.99935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9dcbed100fda05721daf912699d826c7.svg";
export { ForwardRef as ReactComponent };